///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.new_customer_matching = abcsetup.new_customer_matching || {};
abcsetup.new_customer_matching.events = abcsetup.new_customer_matching.events || {};
abcsetup.new_customer_matching.events.common = abcsetup.new_customer_matching.events.common || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.new_customer_matching.events.common = {
    init: function() {
        /* Start date has to be before close date and end date has to be after start date */
        $('#app_models_new_customer_matching_event__event_start_date').on('change', function(e) {
            $('#app_models_new_customer_matching_event__event_end_date').attr('min', moment($(this).val()).add(1, 'd').format('YYYY-MM-DD'));
            $('#app_models_new_customer_matching_event__cm_submission_deadline').attr('min', moment($(this).val()).add(1, 'd').format('YYYY-MM-DD'));
            $('#app_models_new_customer_matching_event__cm_review_deadline').attr('min', moment($(this).val()).add(1, 'd').format('YYYY-MM-DD'));
        });

        $('#app_models_new_customer_matching_event__event_end_date').on('change', function(e) {
            $('#app_models_new_customer_matching_event__event_start_date').attr('max', moment($(this).val()).subtract(1, 'd').format('YYYY-MM-DD'));
        });
    },

    ItemMatchDataTable: {
        init: function() {
            /**
             * Expand/Collapse matches
             */
            $(document).on("click", ".expand-matches", function(event) {
                const table = window.LaravelDataTables["app_data_tables_new_customer_matching_item_match_data_table"];
                const matchTable = $('#matches_' + $(this).data('id'));
                $(this).find('i.fa').toggleClass('fa-plus-square fa-minus-square');
                const tr = $(this).closest('tr');
                const row = table.row(tr);

                // This row is already open - close it
                if (row.child.isShown()) {
                    row.child.hide();
                    tr.removeClass('shown');
                } else {
                    const cols = tr.find('td:visible').length - 1;

                    // Try to match the width of cols to the parent table
                    for (let i = cols; i > 1; i--) {
                        matchTable.find('tr:first td:eq(' + i + ')').width(tr.find('td:visible').eq(i).width());
                    }

                    // Add the match table to the row as a child
                    row.child(matchTable.html()).show();
                    tr.addClass('shown');
                }
            });
        }
    },
}